import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { initUtmify } from './utils/utmify';
import { preloadImages } from './utils/preloadImages';
import { Hero } from './components/Hero';
import { ForYouSection } from './components/ForYouSection';
import { WhatsInside } from './components/WhatsInside';
import { Outcomes } from './components/Outcomes';
import { PurchaseSection } from './components/PurchaseSection';
import { Bonuses } from './components/Bonuses';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
export function App() {
  useEffect(() => {
    initUtmify();
    initMetaPixel();
    preloadImages();
  }, []);
  return <div className="min-h-full w-full overflow-x-hidden bg-cream-100 font-sans" data-id="element-0" data-mp="2wka0gqyiyz29">
      <main className="bg-grid mx-auto w-full max-w-[460px] overflow-x-hidden md:max-w-[1080px]" data-id="element-1" data-mp="2wi5pxq64f1t0">
        <Hero data-id="element-2" data-mp="28s31dk1f0dz5" />
        <ForYouSection data-id="element-3" data-mp="23vkuadim43jn" />
        <WhatsInside data-id="element-4" data-mp="23u9u0nodldxa" />
        <Outcomes data-id="element-5" data-mp="23ut9zyugts8o" />
        <PurchaseSection data-id="element-6" data-mp="23t8h0dnsuhcx" />
        <Bonuses data-id="element-7" data-mp="3ik7eyd5x05p2" />
        <Reviews data-id="element-8" data-mp="3ikqy1x7ax04o" />
        <Faq data-id="element-9" data-mp="3ij668fcdfvai" />
      </main>
    </div>;
}